import { ISubscription } from '@sdk/contracts';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useActivityUIState } from './useActivityUIState';

import { getNextActivityTrack, getPreviousActivityTrack } from '@/utils';

export const useActivityNavigation = (subscription?: ISubscription) => {
  const navigateTo = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const {
    isRecapModalOpen,
    setIsRecapModalOpen,
    showNextActivityShortcut,
    setShowNextActivityShortcut
  } = useActivityUIState();

  const currentActivityId = searchParams.get('activity') ?? subscription?.currentActivity ?? '';

  const previousActivity = getPreviousActivityTrack(subscription, currentActivityId);
  const nextActivity = getNextActivityTrack(subscription, currentActivityId);

  const navigateToNextActivity = () => {
    if (!subscription || !nextActivity) return;
    if (showNextActivityShortcut) setShowNextActivityShortcut(false);
    if (isRecapModalOpen) setIsRecapModalOpen(false);

    if (!nextActivity.activity) return;
    searchParams.set('activity', nextActivity.activity!);
    navigateTo({ pathname, search: searchParams.toString() });
  };

  const navigateToPreviousActivity = () => {
    if (!subscription || !previousActivity) return;
    if (showNextActivityShortcut) setShowNextActivityShortcut(false);
    if (isRecapModalOpen) setIsRecapModalOpen(false);

    if (!previousActivity.activity) return;
    searchParams.set('activity', previousActivity.activity!);
    navigateTo({ pathname, search: searchParams.toString() });
  };

  return { previousActivity, nextActivity, navigateToPreviousActivity, navigateToNextActivity };
};
